import React from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { usePageMetadata } from '../../hooks/usePageMetadata';

export const DynamicPage: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();

    const { data: page, isLoading, isError } = usePageMetadata(slug || '');

    if (isLoading) {
        return (
            <div className="flex justify-center items-center py-32 min-h-[60vh]">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
            </div>
        );
    }

    if (isError || !page) {
        // Page not found -> Redirect to Home or 404
        return <Navigate to="/" replace />;
    }

    if (page.useCustomDesign === true) {
        // Template-based rendering: Allow the template to control full width (e.g. Hero sections)
        return (
            <div className="flex flex-col bg-background min-h-screen overflow-x-hidden">
                <div
                    className="w-full prose-flex-safe"
                    dangerouslySetInnerHTML={{ __html: page.htmlContent?.replace(/&nbsp;/g, ' ') || '' }}
                />
            </div>
        );
    }

    // Default Layout (White Card)
    return (
        <div className="flex flex-col bg-background min-h-screen pb-24">
            <div className="bg-secondary/30 pt-16 pb-24 border-b border-border">
                <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 w-full text-center">
                    <nav className="mb-8 text-sm font-medium text-foreground/60 flex items-center justify-center gap-2">
                        <Link to="/" className="hover:text-primary transition-colors">Startseite</Link>
                        <span>/</span>
                        <span className="text-foreground">{page.title}</span>
                    </nav>

                    <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-foreground">
                        {page.title}
                    </h1>
                </div>
            </div>

            <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 w-full -mt-12 relative z-10">
                <div className="bg-white rounded-3xl shadow-sm border border-border p-8 sm:p-16">
                    <div
                        className="prose prose-lg prose-primary max-w-none text-foreground/80 leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: page.htmlContent?.replace(/&nbsp;/g, ' ') || '' }}
                    />
                </div>
            </div>
        </div>
    );
};
